import React, { useState , useEffect}  from 'react';
import { ObjectId } from 'bson';
import { MdOutlineCancel } from 'react-icons/md';
import { ArrowDownTrayIcon, TrashIcon, EyeIcon } from "@heroicons/react/24/solid";
import { useStateContext } from '../../contexts/ContextProvider';
import { useCarpetasMutations } from '../../hooks'
import { FooterPages } from '..';
import { getCentroCosto } from '../../services/CentroCostos';
import { getMaquinas } from '../../services/Maquinas';
import { crearTicket } from '../../services/Tikets';
import { fetchUser } from '../../utils/fetchUser';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { Toaster,toast } from 'react-hot-toast';
import { uploadFile , downloadFile, fetchFileUrl } from '../../services/filesTools';
import SearchDocumento from '../Search/SearchDocumento';
import SearchDocMaquina from '../Search/SearchDocMaquina';
import { getManDocuMaq, getManDocuMaqFiltro } from '../../services/ManDocuMaq';
import { upsertAcreditacion, getAcreditacionByCarpeta } from '../../services/Acreditacion';
import { getMensajeRol } from '../../services/UsuarioSucursal';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { crearLog } from '../../services/AuditoriaLogs';

import ButtonToolBar from '../ButtonToolBar';
import {formatDate} from '../../formatters/date';

const esPdf = (nombre) => nombre?.toLowerCase().endsWith('.pdf');

const initialState = {
  empresa:null,
  idCarpeta:null,
  numeroCarpeta: 0,
  fechaCreacion: null,
  idCentro:null,
  idMandante:null,
  nombreProyecto:'',
  ubicacion:'',
  idasignaciones:null,
  numeroSolicitud:0,
  nombreAdministrador: '',
  fechaEnObra: null,
  idMaquina:null,
  lin: 0,
  capacidad:'',
  codigoEquipo:'',
  anno:'',
  serie:'',
  patente:'',
  esCritico:'NO',
  documentosRequeridos: [],
  observacionAd:''
  };

const NuevaCarpeta = ({vecinoData, onChangeVecino, soloLectura = false}) => {
  const { isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [tabActiva, setTabActiva] = useState('documentos');
  const [acreditacionData, setAcreditacionData] = useState(null);
  const [centroData, setCentroData] = useState([]);
  const [equipoData, setEquipoData] = useState([]);
  const { updateCarpetaC } = useCarpetasMutations();
  const [estado,setEstado] = useState('');
  const [esCritico,setEsCritico] = useState('NO');
  const [documentos, setDocumentos] = useState([]);

  const [avance,setAvance] = useState('0%');
  const [totalDoc,setTotalDoc] = useState(0);
  const [llevoDoc,setLlevoDoc] = useState(0);
  const [docOptions, setDocOptions] = useState([]);
  const [preview, setPreview] = useState({ open: false, url: null });
  const [docSearch, setDocSearch] = useState({});
  const [docDropdownOpen, setDocDropdownOpen] = useState({});

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
    { name: 'enviar', label: 'Enviar Revisión', disabled: false },
  ]);
  
  const userInfo = fetchUser();

  useEffect(() => {

      // console.log("DATA -> ", JSON.stringify(vecinoData));
      const fetchData = async () => {
      const misCentros = await getCentroCosto();
      setCentroData(misCentros);
      const misEquipos = await getMaquinas();
      setEquipoData(misEquipos);  
      if(vecinoData._id) {
        // console.log(" LLEGO "  + JSON.stringify(vecinoData));
        const cSel = misCentros.find((item) => item._id === vecinoData.idCentro._id);

        const equipoEncontrado = vecinoData.idSolicitud.detalleEquipos.find(
          (equipo) => equipo.lin === vecinoData.lin
        );

        setFormData({...formData,
          idCarpeta: vecinoData._id,
          numeroCarpeta: vecinoData.numeroCarpeta,
          fechaCreacion: vecinoData.idSolicitud.fechaCreacion ? new Date(vecinoData.idSolicitud.fechaCreacion) : null,
          idCentro: vecinoData.idCentro._id,
          idMandante: cSel.idMandante,
          nombreProyecto: cSel.nombreProyecto,
          ubicacion: cSel.ubicacion ,
          numeroSolicitud: vecinoData.idSolicitud.numeroSolicitud,
          nombreAdministrador: cSel.nombreAdministrador,
          fechaEnObra: equipoEncontrado?.fechaEnObra ? new Date(equipoEncontrado.fechaEnObra) : null,
          idasignaciones: vecinoData.idasignaciones._id,
          idMaquina: vecinoData.idMaquina._id, 
          capacidad: equipoEncontrado ? equipoEncontrado.capacidad : '',
          lin: vecinoData.lin, 
          codigoEquipo: vecinoData.codigoEquipo,
          anno: vecinoData.anno, 
          serie: vecinoData.serie, 
          patente: vecinoData.patente, 
          esCritico:  equipoEncontrado ? equipoEncontrado.esCritico : '', 
          estado: vecinoData.estado, 
          documentosRequeridos: vecinoData.documentosRequeridos,
          observacionAd: vecinoData.observacionAd 
           }); 
          let cuantosllevo = 0;

          // ✅ Solo documentos cuyo idDocumento fue encontrado y son tipo Logística (excluye Obra)
          const documentosFiltrados = vecinoData.documentosRequeridos.filter(
            (doc) => doc.idDocumento != null && (!doc.idDocumento?.tipo || doc.idDocumento?.tipo === 'Logística')
          );

          // ✅ Transforma fechas a Date o null
          const documentosSanitizados = documentosFiltrados.map((doc) => {
            const fechaVigencia = doc.fechaVigencia ? new Date(doc.fechaVigencia) : null;
            const nuevaFecha = fechaVigencia ? sumarDias(fechaVigencia, doc.vigenciaEfectiva ?? doc.idDocumento?.vigencia ?? 0) : null;
            const exigeFecha = doc.idDocumento.exigeFecha !== null ? doc.idDocumento.exigeFecha : "NO";
            const fechaVencimiento = doc.fechaVencimiento ? new Date(doc.fechaVencimiento) :  toDateDMY(nuevaFecha);
            // ✅ Contamos si hay un nombreArchivo no vacío
            if (doc.nombreArchivo && doc.nombreArchivo.trim() !== "") {
              cuantosllevo++;
            }

            return {
              ...doc,
              fechaVigencia,
              nuevaFecha,
              exigeFecha,
              fechaVencimiento,
              esCargaMasiva: doc.idDocumento.documentoGeneral === 'CARGA MASIVA'
            };
          });

          console.log("DOCUMENTOS SANITIZADOS -> ", JSON.stringify(documentosSanitizados));
          setDocumentos(documentosSanitizados);
          setTotalDoc(documentosFiltrados.length);
          setLlevoDoc(cuantosllevo);

          const opciones = await getManDocuMaq();
          setDocOptions(opciones || []);

          try {
            const acred = await getAcreditacionByCarpeta(vecinoData._id);
            setAcreditacionData(acred);
          } catch (_) {}

          if (vecinoData.estado !== 'Pendiente') {
            setButtonsTool(prev => prev.map(b => {
              if (b.name === 'enviar') return { ...b, disabled: true };
              if (b.name === 'save' && vecinoData.estado === 'En Revisión') return { ...b, disabled: true };
              return b;
            }));
          }

      }
      
    };
    fetchData();
  },[]);

  useEffect(() => {
          // truncar a 0 decimales
          const porcentaje = totalDoc !== 0 ? 
          Math.round((llevoDoc / totalDoc) * 100) 
          : 0;
          setAvance(`${ porcentaje }%`);
  },[llevoDoc, totalDoc]);


  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeAvance = (e) =>{
    setAvance( e.target.value );
  };

function sumarDias(fechaBase, numDias) {
  let fecha;
//  console.log("FECHA BASE -> ", fechaBase);
//  console.log("NUM DIAS -> ", numDias);

  // Si es una fecha en formato dd/mm/yyyy
  if (typeof fechaBase === 'string' && fechaBase.includes('/') && !isNaN(fechaBase[0])) {
    const [dia, mes, anio] = fechaBase.split('/').map(Number);
    fecha = new Date(anio, mes - 1, dia); // Mes comienza en 0
  } else {
    // Cualquier otro string parseable por Date, o un objeto Date directamente
    fecha = new Date(fechaBase);
  }

  if (isNaN(fecha)) {
    throw new Error('Fecha no válida');
  }

  // Sumar días
  fecha.setDate(fecha.getDate() + numDias);

 // console.log("FECHA SUMADA -> ", fecha);
 // console.log("diasSumada -> ", numDias);

  // Formato final: dd/mm/yyyy
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const anio = fecha.getFullYear();

  return `${dia}/${mes}/${anio}`;
}

function toDateDMY(str) {
  if (!str) return null; // si viene null, undefined, "", etc.

  const [d, m, y] = str.split('/').map(Number);
  return new Date(y, m - 1, d);
}

function diasDiferencia(fechaStr) {
  if (!fechaStr) return { texto: "", dias: 0, vencida: false };

  let fecha;

  if (fechaStr instanceof Date) {
    fecha = new Date(fechaStr);
  } else {
    // Normalizar ISO datetime quitando la parte de hora antes de parsear
    const s = typeof fechaStr === 'string' && fechaStr.includes('T') ? fechaStr.split('T')[0] : fechaStr;
    if (typeof s === 'string' && s.includes('/') && s.split('/').length === 3) {
      const [d, m, y] = s.split('/');
      fecha = new Date(y, m - 1, d);
    } else if (typeof s === 'string' && s.includes('-')) {
      const [y, m, d] = s.split('-');
      fecha = new Date(Number(y), Number(m) - 1, Number(d));
    } else {
      fecha = new Date(s);
    }
  }

  if (isNaN(fecha)) return { texto: "", dias: 0, vencida: false };

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  fecha.setHours(0, 0, 0, 0);

  const diffMs = fecha - hoy;
  const diffDias = Math.round(diffMs / (1000 * 60 * 60 * 24));
  const vencida = diffDias < 0;

  // Formato final dd/mm/yyyy
  const dd = String(fecha.getDate()).padStart(2, "0");
  const mm = String(fecha.getMonth() + 1).padStart(2, "0");
  const yyyy = fecha.getFullYear();

  const formateada = `${dd}/${mm}/${yyyy}`;
  const texto = `${formateada} (${diffDias >= 0 ? diffDias : `-${Math.abs(diffDias)}`}) días`;

  return { texto, dias: diffDias, vencida };
}



function estaVencida(fechaStr) {
  if (!fechaStr) return false; // no evaluar si está vacía o null

  const fecha = new Date(fechaStr);
  if (isNaN(fecha)) return false; // fecha inválida

  const ref = new Date();
  ref.setDate(ref.getDate() - 60);

  return fecha <= ref;
}

  const handleDateChange = (index, date) => {
    const updatedDocs = [...documentos];
    updatedDocs[index].fechaVigencia = date;
    // Actualizar nuevaFecha solo si la fechaVigencia es válida
    updatedDocs[index].nuevaFecha = date ? sumarDias(date, updatedDocs[index].vigenciaEfectiva ?? updatedDocs[index].idDocumento?.vigencia ?? 0) : null;
    setLlevoDoc((prevCount) => prevCount + 1);
    setDocumentos(updatedDocs);
  
    const updatedFormData = { ...formData, documentos: updatedDocs };
    setFormData(updatedFormData);
  };

  
  const handleDateChange2 = (index, date) => {
    const updatedDocs = [...documentos];
    updatedDocs[index].fechaVencimiento = date;

    setLlevoDoc((prevCount) => prevCount + 1);
    setDocumentos(updatedDocs);
  
    const updatedFormData = { ...formData, documentos: updatedDocs };
    setFormData(updatedFormData);
  };
  
 
  const handleChangeEsCritico = (e) =>{
    setEsCritico( e.target.value );
  };

  const handleFileChange = async (index, e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
  
        const response = await uploadFile(selectedFile);
        if (response && response.fileId) {

          setDocumentos((prevDocs) => {
            const updatedDocs = [...prevDocs];
        
            // Verificar si el índice existe en el array, si no, crear un objeto vacío
            if (!updatedDocs[index]) {
              updatedDocs[index] = {};
            }

            updatedDocs[index] = {
              ...updatedDocs[index], // Mantiene los valores anteriores del objeto
              nombreArchivo: selectedFile.name,
              urlArchivo: URL.createObjectURL(selectedFile),
              idArchivo: response.fileId
            };
        
            return updatedDocs;
          });
          setLlevoDoc((prevCount) => prevCount + 1);
        } else {
          toast.error('Error al subir el archivo.');
          console.error('Error de carga:');
        }
  };
  
const handleDeleteDoc = async (index, doc) => {
  try {

    const dataLog = {
      empresa: userInfo.empresa,
      opcion: "Carpetas",
      accion: "Eliminar",
      idUsuario: userInfo.usuario,
      numeroSolicitud: formData.numeroSolicitud,
      encabezado: " Proyecto " + formData.nombreProyecto + " N° Carpeta " + formData.numeroCarpeta ,
      detalle: "Usuario elimino Documento " + (doc.idDocumento?.documentoGeneral ?? 'CARGA MASIVA') + " para equipo " + formData.codigoEquipo
    };

    await crearLog(dataLog);

    setDocumentos((prevDocs) => prevDocs.filter((_, i) => i !== index));


    // Aquí, si también tienes que eliminarlo del backend:
    // await Axios.delete(`/ruta/eliminar/${doc.idArchivo}`);

  } catch (error) {
    console.error("Error eliminando documento:", error);
  }
} 

  
  const descargarDocumento = async (doc) => {
    if (doc.idArchivo) {
      await downloadFile(doc.idArchivo, doc.nombreArchivo || "documento.pdf");
    }
  };

  const previsualizarDocumento = async (doc) => {
    if (!doc.idArchivo) return;
    const url = await fetchFileUrl(doc.idArchivo);
    setPreview({ open: true, url });
  };

  const cerrarPreview = () => {
    if (preview.url) window.URL.revokeObjectURL(preview.url);
    setPreview({ open: false, url: null });
  };
  
  const handleEnviarAprobacion = async () =>{

    if ( formData.estado === 'Rechazada'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }

    if (documentos.some(d => d.esCargaMasiva)) {
      toast.error('Hay documentos de carga masiva sin asignar. Selecciona el tipo de cada uno antes de enviar a revisión.');
      return;
    }

    if (hayDocumentosDuplicados()) {
      toast.error('Hay documentos duplicados en la tabla. Corrígelos antes de enviar a revisión.');
      return;
    }

    // Validar que todos los documentos tengan fecha de vigencia
    const documentosInvalidos = documentos.filter(
      doc => doc.exigeFecha == 'SI' && !doc.fechaVigencia
    );

    if (documentosInvalidos.length > 0) {
      toast.error('Se deben ingresar todos los documentos para Enviar a Revisión de Expeditores.');
      return;
    }

    const documentosSinArchivo = documentos.filter(
      doc => !doc.nombreArchivo || doc.nombreArchivo.trim() === ''
    );
    if (documentosSinArchivo.length > 0) {
      toast.error(`Hay ${documentosSinArchivo.length} documento(s) sin archivo cargado. Sube todos los archivos antes de enviar a revisión.`);
      return;
    }

    const documentosVencidos = documentos.filter(
      doc => doc.exigeFecha === 'SI' && diasDiferencia(doc.fechaVencimiento || doc.nuevaFecha).vencida
    );
    if (documentosVencidos.length > 0) {
      toast.error(`Hay ${documentosVencidos.length} documento(s) vencido(s). Actualiza los archivos antes de enviar a revisión.`);
      return;
    }

    setButtonsTool(prev => prev.map(b => ({ ...b, disabled: true })));

    const updatosCarpeta = {
      _id: vecinoData._id,
      empresa: userInfo.empresa,
      numeroCarpeta: formData.numeroCarpeta,
      idMaquina: formData.idMaquina,
      idCentro: formData.idCentro,
      idasignaciones: formData.idasignaciones,
      lin: formData.lin,
      idSolicitud: formData.idSolicitud,
      anno: formData.anno,
      patente: formData.patente,
      serie: formData.serie,
      documentosRequeridos: normalizarDocumentos(documentos),
      fechaCreacion: formData.fechaCreacion,
      estado: 'En Revisión'
    };
    await updateCarpetaC.mutateAsync( updatosCarpeta );

    // Obtener documentos de tipo Obra para la acreditación
    try {
      const todosManDoc = await getManDocuMaqFiltro(formData.idMandante, formData.idMaquina);
      const docsObra = (todosManDoc || [])
        .filter(d => d.tipo === 'Obra')
        .map(d => ({ idDocuGeneral: d.idDocuGeneral, documentoGeneral: d.documentoGeneral }));

      const docsLogistica = documentos.map(d => ({
        idDocumento: d.idDocumento?._id ?? d.idDocumento,
        documentoGeneral: d.idDocumento?.documentoGeneral ?? '',
        nombreArchivo: d.nombreArchivo || null,
        idArchivo: d.idArchivo || null,
        fechaVigencia: d.fechaVigencia || null,
        fechaVencimiento: d.fechaVencimiento || null,
      }));

      await upsertAcreditacion({
        empresa: userInfo.empresa,
        idCarpeta: vecinoData._id,
        numeroCarpeta: formData.numeroCarpeta,
        codigoEquipo: formData.codigoEquipo,
        serie: formData.serie,
        patente: formData.patente,
        anno: formData.anno,
        idMaquina: formData.idMaquina,
        idMandante: formData.idMandante,
        idCentro: formData.idCentro,
        idSolicitud: formData.idSolicitud?._id ?? formData.idSolicitud,
        idasignaciones: formData.idasignaciones,
        lin: formData.lin,
        documentosObra: docsObra,
        documentosLogistica: docsLogistica,
        idUsuario: userInfo.usuario,
        nombreUsuario: userInfo.nombre || '',
      });
    } catch (err) {
      console.error('Error creando acreditación:', err);
    }

    const dataBase = {
      empresa: userInfo.empresa,
      tipo: 'Expeditor',
      numTicket: 0, // Número secuencial
      requerimiento: 'Solicitud de Revisión Carpeta - ' + formData.codigoEquipo,
      observacion: 'Se solicita realizar a la brevedad la revisión de la Carpeta del equipamiento ' + formData.codigoEquipo,
      documentosRespaldo: [],
      fechaEntrega: null,
      numOT:'',
      fechaCreacion: new Date().toISOString(),
      idCreador: userInfo.usuario,
      idAsignado: null,
      idCarpeta: vecinoData._id,
      estado: 'Pendiente',
    };

    // console.log('crear VECINO'); const miTicket =
    await crearTicket( dataBase );

    const mUser = await getMensajeRol('Expeditor');
    const dataMensaje = {
    numeroCarpeta: formData.numeroCarpeta,
    serie: formData.serie , 
    patente: formData.patente, 
    codigoEquipo: formData.codigoEquipo
   };
    if (mUser){
      mUser.forEach(element => {     
        let mensaje = crearMensaje(element._id, 'ticketExpeditor', dataMensaje);
        notificarUsuario(JSON.stringify(mensaje));
      });
    }

    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevaCarpeta );

  };

  const hayDocumentosDuplicados = () => {
    // Excluir solo los slots CARGA MASIVA que aún no tienen tipo asignado
    const ids = documentos
      .filter(d => d.idDocumento?.documentoGeneral !== 'CARGA MASIVA')
      .map(d => String(d.idDocumento?._id || d.idDocumento));
    return ids.length !== new Set(ids).size;
  };

  const handleSubmit = async () =>{

    if (hayDocumentosDuplicados()) {
      toast.error('Hay documentos duplicados en la tabla. Corrígelos antes de guardar.');
      return;
    }

    if (formData.estado === 'En Revisión') {
      toast.error('No se puede guardar mientras la carpeta está en revisión.');
      return;
    }

    setButtonsTool(prev => prev.map(b => ({ ...b, disabled: true })));

    try {
      await updateCarpetaC.mutateAsync({
        _id: vecinoData._id,
        empresa: userInfo.empresa,
        numeroCarpeta: formData.numeroCarpeta,
        idMaquina: formData.idMaquina,
        idCentro: formData.idCentro,
        idasignaciones: formData.idasignaciones,
        lin: formData.lin,
        idSolicitud: formData.idSolicitud,
        anno: formData.anno,
        patente: formData.patente,
        serie: formData.serie,
        documentosRequeridos: normalizarDocumentos(documentos),
        fechaCreacion: formData.fechaCreacion,
        idUsuario: userInfo.usuario,
        nombreUsuario: userInfo.nombre || '',
      });

      setDocumentos(prev => prev.map(doc => ({
        ...doc,
        esCargaMasiva: doc.esCargaMasiva && doc.idDocumento.documentoGeneral === 'CARGA MASIVA'
      })));

      aplicarReglasBotones(formData.estado);
    } catch (e) {
      console.error('Error guardando carpeta:', e);
      aplicarReglasBotones(formData.estado);
    }
  }
 
  const handleCancelar = async () =>{
    if (estado === 'Aprobada' || estado === 'Rechazada'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }
    const updatosCarpeta = {
      _id: vecinoData._id,
      empresa: userInfo.empresa,
      numeroCarpeta: formData.numeroCarpeta,
      idMaquina: formData.idMaquina,
      idCentro: formData.idCentro,
      idasignaciones: formData.idasignaciones,
      lin: formData.lin,
      idSolicitud: formData.idSolicitud?._id ?? formData.idSolicitud,
      anno: formData.anno,
      patente: formData.patente,
      serie: formData.serie,
      documentosRequeridos: normalizarDocumentos(documentos),
      fechaCreacion: formData.fechaCreacion,
      estado: 'Rechazada'
    };
    await updateCarpetaC.mutateAsync( updatosCarpeta );
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevaCarpeta );
  }


  const normalizarDocumentos = (docs) =>
    docs.map(doc => ({
      ...doc,
      idDocumento: doc.idDocumento?._id ?? doc.idDocumento,
    }));

  const handleDocumentoChange = (index, selectedDocId) => {
    const selected = docOptions.find(d => d._id === selectedDocId);
    if (!selected) return;

    const updatedDocs = [...documentos];
    updatedDocs[index] = {
      ...updatedDocs[index],
      idDocumento: {
        _id: selected._id,
        documentoGeneral: selected.documentoGeneral,
        exigeFecha: selected.exigeFecha,
        vigencia: selected.vigencia,
      },
      exigeFecha: selected.exigeFecha,
    };
    setDocumentos(updatedDocs);
  };

  const aplicarReglasBotones = (nuevoEstado) => {
    setButtonsTool(prev => prev.map(b => ({
      ...b,
      disabled: b.name === 'enviar'
        ? nuevoEstado !== 'Pendiente'
        : b.name === 'save'
          ? nuevoEstado === 'En Revisión'
          : false,
    })));
  };

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'enviar') {
      handleEnviarAprobacion();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    }
  };

  const handleCambiarTab = async (tab) => {
    setTabActiva(tab);
    if (tab === 'historial' && vecinoData?._id && !acreditacionData) {
      try {
        const result = await getAcreditacionByCarpeta(vecinoData._id);
        setAcreditacionData(result);
      } catch (err) {
        console.error('Error cargando historial acreditación:', err);
      }
    }
  };

  const estadoBadgeHistorial = (estado) => {
    const map = {
      'Pendiente': 'bg-yellow-100 text-yellow-700',
      'Aprobada':  'bg-green-100 text-green-700',
      'Rechazada': 'bg-red-100 text-red-700',
    };
    return (
      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${map[estado] || 'bg-gray-100 text-gray-600'}`}>
        {estado}
      </span>
    );
  };

  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nueva" : "Editar"} Carpeta
              </p>
            </div>

            <button
              type="button"
              onClick={() => { onChangeVecino('REFRESH'); setIsClicked(!isClicked.nuevaCarpeta)}}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>


     <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-3 md:grid-cols-10 gap-4" >
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Carpeta</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroCarpeta"
                value= {formData.numeroCarpeta}
                disabled
              />
            </div>
            <div className="flex flex-col items-start">      
              <label className="text-xs font-semibold mb-1">Fecha</label>            
              <input
                className={inputClass}
                type="text"
                placeholder=""
                name="fechaCreacion"
                value= {formatDate(formData.fechaCreacion)}
                disabled
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Centro Costo</label>
              <select className={inputClass} name="idCentro" disabled value={formData.idCentro} onChange={handleChange}>
              <option value=""></option>
              {centroData?.map((item, index) => (
                <option  key={item._id} value={item._id}>{item.codigo}</option>
              ))}  
              </select>
            </div> 

            <div className="col-span-2">
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Proyecto</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="nombreProyecto"
                      value= {formData.nombreProyecto}
                      disabled
                      onChange={handleChange}
                    />
                </div>
              </div>

              <div className="col-span-2">
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Ubicación</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="ubicacion"
                        value= {formData.ubicacion}
                        disabled
                        onChange={handleChange}
                      />
                  </div>
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Solicitud</label>
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroSolicitud"
                value= {formData.numeroSolicitud}
                disabled
                onChange={handleChange}
                />
              </div> 
   
                  
                <div className="col-span-2">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Administrador</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="nombreAdministrador"
                          value= {formData.nombreAdministrador}
                          disabled
                          onChange={handleChange}
                        />
                  </div> 
                </div> 
          </div>
          <div className="grid grid-cols-3 md:grid-cols-10 gap-4 mt-2" >
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Fecha en Obra</label>
                    <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="fechaEnObra"
                          value={formatDate(formData.fechaEnObra)}
                          disabled
                          onChange={handleChange}
                        />
                </div>
                <div className="col-span-2">
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Maquina</label>
                      <select className={inputClass} name="idMaquina"
                        value={formData.idMaquina} disabled onChange={handleChange}>
                      <option value=""></option>
                      {equipoData?.map((item, index) => (
                        <option  key={item._id} value={item._id}>{item.codigo}</option>
                      ))}  
                      </select>
                    </div>
                </div>
                <div className="flex flex-col">
                     <label className="text-xs font-semibold mb-1">Capacidad</label>
                     <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="capacidad"
                      disabled
                      value= {formData.capacidad}
                      onChange={handleChange}
                    />
                  </div>  
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Año</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="anno"
                      value= {formData.anno}
                      onChange={handleChange}
                      disabled
                    />
                </div>  
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Serie</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="serie"
                      value= {formData.serie}
                      onChange={handleChange}
                      disabled
                    />
                </div>  
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Patente</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="patente"
                      value= {formData.patente}
                      onChange={handleChange}
                      disabled
                    />
                </div> 
                <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Es crítico</label>
                      <select className={inputClass} disabled name="esCritico" value={formData.esCritico} required onChange={handleChangeEsCritico}>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                </div>  
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">N° Interno</label>
                      <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="codigoEquipo"
                        value= {formData.codigoEquipo}
                        onChange={handleChange}
                        disabled
                      />

                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Avance</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="avance"
                        value= {avance}
                        onChange={handleChangeAvance}
                        disabled
                      />
                  </div>
            </div>
        </div>

        {/* Pestañas */}
        {vecinoData && (
          <div className="flex gap-1 mt-4 border-b border-gray-300">
            {[
              { id: 'documentos', label: 'Documentos' },
              { id: 'historial',  label: 'Historial Acreditación' },
            ].map(t => (
              <button key={t.id} type="button" onClick={() => handleCambiarTab(t.id)}
                className={`text-xs font-semibold px-4 py-2 rounded-t border transition-colors ${
                  tabActiva === t.id
                    ? 'bg-white border-gray-300 border-b-white text-blue-600 -mb-px'
                    : 'bg-gray-100 border-transparent text-gray-500 hover:text-gray-700'
                }`}>
                {t.label}
              </button>
            ))}
          </div>
        )}

          {tabActiva === 'documentos' && <div className="mt-5 space-y-4">

              <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >

                    <div className="flex flex-col">
                            <SearchDocMaquina
                                proyecto={formData.idMandante}
                                maquina={formData.idMaquina}
                                onValorSeleccionadoChange={(docSeleccionado) => {
                                  if (!docSeleccionado) return;
                                  console.log("DOC SELECCIONADO -> ", JSON.stringify(docSeleccionado));
                                  setDocumentos((prevDocs) => {
                                    // Verificar si el documento ya existe en la lista
                                    const existe = prevDocs.some(
                                      (doc) => doc.idDocumento._id === docSeleccionado.idDocuGeneral
                                    );
                                    if (existe) {
                                      toast.error('El documento ya existe en la Carpeta.');
                                      return prevDocs; // No agregar duplicados
                                    }

                                    const nuevoDoc = {
                                        _id: new ObjectId().toString(),
                                        idDocumento: {
                                            _id: docSeleccionado.idDocuGeneral,
                                            documentoGeneral: docSeleccionado.documentoGeneral,
                                            exigeFecha: docSeleccionado.exigeFecha,
                                            vigencia: docSeleccionado.vigencia
                                        },
                                        fechaVigencia: null,
                                        nombreArchivo: "",
                                        urlArchivo: "",
                                        idArchivo: null,
                                        // Estos campos se calcularán después cuando se asigne fechaVigencia
                                        fechaVencimiento: null,
                                        nuevaFecha: null,
                                        exigeFecha: docSeleccionado.exigeFecha,
                                        
                                        // Campos adicionales útiles
                                        creadoEn: new Date().toISOString(),
                                        actualizadoEn: new Date().toISOString()
                                    };
                                      
                                    return [...prevDocs, nuevoDoc];
                                  });
                                }}
                              />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >

                    <div className="flex flex-col">
                    <table className="w-full border-collapse border border-gray-300 text-sm mt-2">
                      <thead>
                        <tr className="bg-gray-200 text-left">
                          <th className="text-xs font-semibold p-2 w-2/6 border">Documento</th>
                          <th className="text-xs font-semibold p-2 w-1/6 border">Fecha Emisión</th>
                          <th className="text-xs font-semibold p-2 w-1/6 border">Vigencia</th>
                          <th className="text-xs font-semibold p-2 w-1/6 border">Fecha Vencimiento</th> 
                          <th className="text-xs font-semibold p-2 w-1/6 border">Archivo*</th>
                          <th className="text-xs font-semibold p-2 w-1/6 border">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {documentos.map((doc, index) => {
                          const idDoc = String(doc.idDocumento?._id || doc.idDocumento || '');
                          const rechazo = acreditacionData?.documentosLogistica?.find(
                            d => String(d.idDocumento) === idDoc
                          );
                          const rechazado = rechazo?.estado === 'Rechazado';
                          return (
                          <tr key={index} className={`border border-gray-300${rechazado ? ' bg-red-50' : ''}`}>
                            {/* Documento */}
                            <td className={`border p-2 font-semibold${rechazado ? ' bg-red-100' : ' bg-gray-100'}`}>
                              {doc.esCargaMasiva ? (
                                <div className="relative">
                                  <input
                                    type="text"
                                    className="text-[11px] border border-gray-300 p-1 rounded w-full font-normal"
                                    placeholder="-- Buscar tipo --"
                                    value={docSearch[index] || ''}
                                    onChange={(e) => setDocSearch(prev => ({ ...prev, [index]: e.target.value }))}
                                    onFocus={() => setDocDropdownOpen(prev => ({ ...prev, [index]: true }))}
                                    onBlur={() => setTimeout(() => setDocDropdownOpen(prev => ({ ...prev, [index]: false })), 150)}
                                  />
                                  {docDropdownOpen[index] && (
                                    <div className="absolute z-50 left-0 mt-1 min-w-[18rem] bg-white border border-gray-300 rounded shadow-lg max-h-48 overflow-y-auto">
                                      {docOptions
                                        .filter(opt => opt.documentoGeneral.toLowerCase().includes((docSearch[index] || '').toLowerCase()))
                                        .map(opt => (
                                          <div
                                            key={opt._id}
                                            className="text-[11px] px-2 py-1.5 hover:bg-blue-100 cursor-pointer"
                                            onMouseDown={() => {
                                              const esDuplicado = documentos.some((d, i) =>
                                                i !== index &&
                                                d.idDocumento?.documentoGeneral !== 'CARGA MASIVA' &&
                                                String(d.idDocumento?._id || d.idDocumento) === String(opt._id)
                                              );
                                              if (esDuplicado) {
                                                toast.error('Ese tipo de documento ya existe en la tabla.');
                                                setDocDropdownOpen(prev => ({ ...prev, [index]: false }));
                                                return;
                                              }
                                              handleDocumentoChange(index, opt._id);
                                              setDocSearch(prev => ({ ...prev, [index]: opt.documentoGeneral }));
                                              setDocDropdownOpen(prev => ({ ...prev, [index]: false }));
                                            }}
                                          >
                                            {opt.documentoGeneral}
                                          </div>
                                        ))
                                      }
                                      {docOptions.filter(opt => opt.documentoGeneral.toLowerCase().includes((docSearch[index] || '').toLowerCase())).length === 0 && (
                                        <div className="text-[11px] px-2 py-1.5 text-gray-400">Sin resultados</div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                doc.idDocumento.documentoGeneral
                              )}
                              {rechazado && (
                                <p className="text-[10px] text-red-600 mt-1 font-normal italic">
                                  ⚠ {rechazo.comentario || 'Documento rechazado en acreditación'}
                                </p>
                              )}
                            </td>

                            {/* Fecha de Vigencia */}
                            <td className="border p-2">
                              { doc.exigeFecha !== "SI" ? "N/A" :
                                <SeleccionaFecha
                                  selectedDate={doc.fechaVigencia}
                                  handleDateChange={(date) => handleDateChange(index, date)}
                                />
                              }

                            </td>
                            <td
                              className={`border p-2 font-semibold ${
                                diasDiferencia(doc.fechaVencimiento || doc.nuevaFecha).vencida
                                  ? 'bg-red-300 text-red-900'
                                  : 'bg-gray-100'
                                  }`}
                                >
                              { doc.exigeFecha !== "SI" ? "N/A" : diasDiferencia(doc.fechaVencimiento || doc.nuevaFecha).texto}
                            </td>

                            {/* Fecha de Vencimiento */}
                            <td className="border p-2">
                              { doc.exigeFecha !== "SI" ? "N/A" :
                                <SeleccionaFecha
                                  selectedDate={doc.fechaVencimiento}
                                  handleDateChange={(date) => handleDateChange2(index, date)}
                                />
                              }

                            </td>

                            {/* Archivo */}
                            <td className="border p-2">
                              <div className="flex flex-col">
                                <input
                                  type="file"
                                  accept=".pdf,.xlsx,.xls,.zip,.rar,.docx,.doc,.png,.jpg,.jpeg"
                                  onChange={(e) => handleFileChange(index, e)}
                                  className="mt-2"
                                />
                                {doc.urlArchivo && (
                                  <p className="text-xs text-gray-600 mt-1">Archivo: {doc.nombreArchivo}</p>
                                )}
                              </div>
                            </td>

                            {/* Acciones */}
                            <td className="border p-2">
                              <div className="flex gap-2">
                              <SearchDocumento
                                serie={formData.serie}
                                patente={formData.patente}
                                index={index}
                                onValorSeleccionadoChange={(docSeleccionado, index) => {
                                  if (!docSeleccionado) return;

                                  setDocumentos((prevDocs) => {
                                    const updatedDocs = [...prevDocs];

                                    if (!updatedDocs[index]) {
                                      updatedDocs[index] = {};
                                    }

                                    updatedDocs[index] = {
                                      ...updatedDocs[index],
                                      nombreArchivo: docSeleccionado.nombreArchivo,
                                      idArchivo: docSeleccionado.idArchivo,
                                      fechaVigencia: docSeleccionado.fechaVigencia || null
                                    };

                                    return updatedDocs;
                                  });
                                }}
                              />

                                  {/* Botón Vista previa */}
                                <button
                                  type="button"
                                  className="p-1 bg-indigo-500 text-white rounded hover:bg-indigo-600 disabled:opacity-40"
                                  onClick={() => previsualizarDocumento(doc)}
                                  disabled={!doc.idArchivo || !esPdf(doc.nombreArchivo)}
                                  title="Vista previa"
                                >
                                  <EyeIcon className="w-4 h-4" />
                                </button>
                                  {/* Botón Descargar */}
                                <button
                                  type="button"
                                  className="p-1 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-40"
                                  onClick={() => descargarDocumento(doc)}
                                  disabled={!doc.urlArchivo}
                                  title="Descargar documento"
                                >
                                  <ArrowDownTrayIcon className="w-4 h-4" />
                                </button>
                                {/* Botón Eliminar */}
                                <button
                                  type="button"
                                  className="p-1 bg-red-500 text-white rounded hover:bg-red-600"
                                  onClick={() => handleDeleteDoc(index, doc)}
                                  title="Eliminar documento"
                                >
                                  <TrashIcon className="w-4 h-4" />
                                </button>

                              </div>
                            </td>
                          </tr>
                          );
                        })}
                      </tbody>
                    </table>



                    </div>


                </div>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-4" >
                    <div className="flex flex-col">

                    </div>
                </div>
              </div>

              {acreditacionData && (
                <div className="bg-white p-6 rounded-lg shadow-lg">
                  <p className="text-sm font-bold text-gray-700 mb-4 border-b pb-2">Detalle Acreditación</p>

                  {/* Técnica */}
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Acreditación Técnica</p>
                  <div className="space-y-2 mb-5">
                    {[
                      { label: 'Checklist', item: acreditacionData.tecnica?.checklist },
                    ].map(({ label, item }) => (
                      <div key={label} className={`flex flex-col gap-2 text-xs rounded p-3 border ${item?.estado === 'Rechazado' ? 'border-red-200 bg-red-50' : 'border-gray-200'}`}>
                        <div className="flex flex-wrap items-center gap-3">
                          <span className={`px-2 py-0.5 rounded-full font-medium shrink-0 ${
                            item?.estado === 'Aprobado'  ? 'bg-green-100 text-green-700' :
                            item?.estado === 'Rechazado' ? 'bg-red-100 text-red-700' :
                            'bg-gray-100 text-gray-500'
                          }`}>{item?.estado || 'Pendiente'}</span>
                          {item?.idArchivo && (
                            <div className="flex gap-1.5 ml-auto">
                              <button type="button" title="Vista previa"
                                className="p-1 bg-indigo-500 text-white rounded hover:bg-indigo-600 disabled:opacity-40"
                                disabled={!esPdf(item?.nombreArchivo)}
                                onClick={() => previsualizarDocumento(item)}>
                                <EyeIcon className="w-4 h-4" />
                              </button>
                              <button type="button" title="Descargar"
                                className="p-1 bg-green-500 text-white rounded hover:bg-green-600"
                                onClick={() => descargarDocumento(item)}>
                                <ArrowDownTrayIcon className="w-4 h-4" />
                              </button>
                            </div>
                          )}
                        </div>
                        {item?.estado === 'Rechazado' && item?.motivos?.length > 0 && (
                          <div className="flex flex-wrap gap-1.5 pl-1">
                            {item.motivos.map(m => (
                              <span key={m} className="px-2 py-0.5 rounded-full bg-red-100 text-red-700 border border-red-300 font-medium">{m}</span>
                            ))}
                          </div>
                        )}
                        {item?.estado === 'Rechazado' && item?.comentario && (
                          <span className="text-red-600 italic pl-1">{item.comentario}</span>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Documentos Obra */}
                  <div className="border-t border-gray-200 pt-4">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Documentos de Obra</p>
                    {(!acreditacionData.documentosObra || acreditacionData.documentosObra.length === 0)
                      ? <p className="text-xs text-gray-400 italic">Sin documentos de obra.</p>
                      : <table className="w-full border-collapse border border-gray-300 text-sm">
                          <thead>
                            <tr className="bg-gray-200 text-left">
                              <th className="text-xs font-semibold p-2 border w-2/6">Documento</th>
                              <th className="text-xs font-semibold p-2 border">Fecha Emisión</th>
                              <th className="text-xs font-semibold p-2 border">Vigencia</th>
                              <th className="text-xs font-semibold p-2 border">Fecha Vencimiento</th>
                              <th className="text-xs font-semibold p-2 border">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {acreditacionData.documentosObra.map((doc, i) => {
                              const vig = diasDiferencia(doc.fechaVencimiento);
                              return (
                              <tr key={i} className="border border-gray-300">
                                <td className="border p-2 bg-gray-100 font-semibold text-xs">{doc.documentoGeneral}</td>
                                <td className="border p-2 text-xs">{doc.fechaVigencia ? formatDate(new Date(doc.fechaVigencia)) : '—'}</td>
                                <td className={`border p-2 text-xs font-semibold ${vig.vencida ? 'bg-red-300 text-red-900' : 'bg-gray-100'}`}>{vig.texto || '—'}</td>
                                <td className="border p-2 text-xs">{doc.fechaVencimiento ? formatDate(new Date(doc.fechaVencimiento)) : '—'}</td>
                                <td className="border p-2">
                                  <div className="flex gap-2">
                                    <button type="button" title="Vista previa"
                                      className="p-1 bg-indigo-500 text-white rounded hover:bg-indigo-600 disabled:opacity-40"
                                      onClick={() => previsualizarDocumento(doc)} disabled={!doc.idArchivo || !esPdf(doc.nombreArchivo)}>
                                      <EyeIcon className="w-4 h-4" />
                                    </button>
                                    <button type="button" title="Descargar"
                                      className="p-1 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-40"
                                      onClick={() => descargarDocumento(doc)} disabled={!doc.idArchivo}>
                                      <ArrowDownTrayIcon className="w-4 h-4" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              );
                            })}
                          </tbody>
                        </table>
                    }
                  </div>
                </div>
              )}

              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4" >
                    <div className="col-span-4">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="observacionAd"
                              value= {formData.observacionAd}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >

                {!soloLectura && (
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                </div>
                )}

                </div>

              </div>
          </div>}

          {tabActiva === 'historial' && (
            <div className="mt-5 bg-white p-6 rounded-lg shadow-lg">
              <p className="text-sm font-bold text-gray-700 mb-3 border-b pb-2">Historial Acreditación</p>
              {!acreditacionData || acreditacionData.historial.length === 0
                ? <p className="text-xs text-gray-400 italic">Sin historial registrado.</p>
                : <table className="w-full text-xs">
                    <thead>
                      <tr className="bg-gray-50 text-left text-gray-500 uppercase tracking-wide">
                        <th className="px-3 py-2 font-semibold">Fecha</th>
                        <th className="px-3 py-2 font-semibold">Acción</th>
                        <th className="px-3 py-2 font-semibold">Usuario</th>
                      </tr>
                    </thead>
                    <tbody>
                      {acreditacionData.historial.map((h, i) => (
                        <tr key={i} className="border-t border-gray-100 hover:bg-gray-50">
                          <td className="px-3 py-2 text-gray-500 whitespace-nowrap">{formatDate(h.fecha)}</td>
                          <td className="px-3 py-2 text-gray-700">{h.accion}</td>
                          <td className="px-3 py-2 text-gray-700">{h.nombre || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
              }
            </div>
          )}

              {preview.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                  <div className="bg-white rounded-lg shadow-xl w-11/12 h-5/6 flex flex-col">
                    <div className="flex justify-between items-center px-4 py-2 border-b">
                      <span className="text-sm font-semibold text-gray-700">Vista previa</span>
                      <button
                        type="button"
                        onClick={cerrarPreview}
                        className="text-gray-400 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-gray-100"
                      >
                        <MdOutlineCancel className="text-xl" />
                      </button>
                    </div>
                    <iframe
                      src={preview.url}
                      className="flex-1 w-full rounded-b-lg"
                      title="Vista previa documento"
                    />
                  </div>
                </div>
              )}
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />
              <FooterPages />

        </div>
      </div>
    </form>
  );
};

export default NuevaCarpeta;